export default {"src":"/_next/static/media/icon-terraced.6665d969.svg","height":26,"width":30,"blurWidth":0,"blurHeight":0};